import type { AsyncTask } from './types';

export const refineAsyncTask = (obj: unknown): AsyncTask | undefined => {
	if (!obj || typeof obj !== 'object') return undefined;

	if (!('task' in obj) || typeof obj.task !== 'object' || !obj.task) return undefined;

	if (!('id' in obj.task) || typeof obj.task.id !== 'string') return undefined;
	if (!('self' in obj.task) || typeof obj.task.self !== 'string') return undefined;

	return {
		task: {
			id: obj.task.id,
			self: obj.task.self,
		},
	};
};
